import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=4f6530f3&scoped=true"
import script from "./orderManage.vue?vue&type=script&lang=js"
export * from "./orderManage.vue?vue&type=script&lang=js"
import style0 from "./orderManage.vue?vue&type=style&index=0&id=4f6530f3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6530f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6530f3')) {
      api.createRecord('4f6530f3', component.options)
    } else {
      api.reload('4f6530f3', component.options)
    }
    module.hot.accept("./orderManage.vue?vue&type=template&id=4f6530f3&scoped=true", function () {
      api.rerender('4f6530f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/mall/orderManage.vue"
export default component.exports